__webpack_require__.p = "/static/scripts/";